import apiAction from 'common/actions/api'

const organizationApi = apiAction('organization')

export const loadOverview = () => {
  return organizationApi('overview', {})
}
